import React from 'react'

export const CompareArrow = ({ fill, direction, width, height }) => {
    if (direction === 'up') {
        return (
            <svg
                width={width}
                height={height}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M19.281 11.0302C19.2114 11.1 19.1287 11.1553 19.0376 11.193C18.9466 11.2308 18.849 11.2502 18.7504 11.2502C18.6519 11.2502 18.5543 11.2308 18.4632 11.193C18.3722 11.1553 18.2894 11.1 18.2198 11.0302L12.7504 5.55993V20.2496C12.7504 20.4485 12.6714 20.6393 12.5307 20.7799C12.3901 20.9206 12.1993 20.9996 12.0004 20.9996C11.8015 20.9996 11.6107 20.9206 11.4701 20.7799C11.3294 20.6393 11.2504 20.4485 11.2504 20.2496V5.55993L5.78104 11.0302C5.64031 11.171 5.44944 11.25 5.25042 11.25C5.05139 11.25 4.86052 11.171 4.71979 11.0302C4.57906 10.8895 4.5 10.6986 4.5 10.4996C4.5 10.3006 4.57906 10.1097 4.71979 9.96899L11.4698 3.21899C11.5394 3.14926 11.6222 3.09394 11.7132 3.05619C11.8043 3.01845 11.9019 2.99902 12.0004 2.99902C12.099 2.99902 12.1966 3.01845 12.2876 3.05619C12.3787 3.09394 12.4614 3.14926 12.531 3.21899L19.281 9.96899C19.3508 10.0386 19.4061 10.1214 19.4438 10.2124C19.4816 10.3035 19.501 10.4011 19.501 10.4996C19.501 10.5982 19.4816 10.6958 19.4438 10.7868C19.4061 10.8779 19.3508 10.9606 19.281 11.0302Z"
                    fill={fill}
                />
            </svg>
        )
    } else {
        return (
            <svg
                width={width}
                height={height}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M19.281 14.0306L12.531 20.7806C12.4614 20.8504 12.3787 20.9057 12.2876 20.9434C12.1966 20.9812 12.099 21.0006 12.0004 21.0006C11.9019 21.0006 11.8043 20.9812 11.7132 20.9434C11.6222 20.9057 11.5394 20.8504 11.4698 20.7806L4.71979 14.0306C4.57906 13.8899 4.5 13.699 4.5 13.5C4.5 13.301 4.57906 13.1101 4.71979 12.9694C4.86052 12.8286 5.05139 12.7496 5.25042 12.7496C5.44944 12.7496 5.64031 12.8286 5.78104 12.9694L11.2504 18.4397V3.75C11.2504 3.55109 11.3294 3.36032 11.4701 3.21967C11.6107 3.07902 11.8015 3 12.0004 3C12.1993 3 12.3901 3.07902 12.5307 3.21967C12.6714 3.36032 12.7504 3.55109 12.7504 3.75V18.4397L18.2198 12.9694C18.3605 12.8286 18.5514 12.7496 18.7504 12.7496C18.9494 12.7496 19.1403 12.8286 19.281 12.9694C19.4218 13.1101 19.5008 13.301 19.5008 13.5C19.5008 13.699 19.4218 13.8899 19.281 14.0306Z"
                    fill={fill}
                />
            </svg>
        )
    }
}
